export default __webpack_public_path__ + "static/media/flight.cbe6d429.svg";